import { lazy } from 'solid-js'

import { messages } from '../../pages/location-landing-page/location-landing-page-routing.messages.en.js'

// Landing pages live under `/search/<country>/<region>[/<town>]`, which is what
// `routeFor()` builds and what Phase 2 prerenders. `/search` itself stays the search page — these
// are deeper paths, so they do not shadow it.
const component = lazy(() => import('../../pages/location-landing-page/location-landing-page.jsx'))

const routeDefaults = {
    component,
    descriptionMessage: messages.descriptionMessage,
    showFooter: true,
    showHeader: true,
    titleMessage: messages.titleMessage,
}

export const locationRegionLandingRouting = {
    ...routeDefaults,
    path: '/search/:countrySlug/:regionSlug',
}

export const locationTownLandingRouting = {
    ...routeDefaults,
    path: '/search/:countrySlug/:regionSlug/:townSlug',
}
